<script setup>
import { ref } from 'vue';

const props = defineProps({
    tabs: {
        type: Array, // Array of objects each having a title and a key
        required: true,
    },
    initialActiveTab: {
        type: Number,
        default: 0,
    },
});


const activeTabIndex = ref(props.initialActiveTab);

</script>


<template>
    <ul class="nav nav-tabs">
        <li
            class="nav-item"
            v-for="tab, index in tabs"
            :key="tab.key"
        >
            <a
                class="nav-link"
                :class="{ active: index === activeTabIndex }"
                @click.prevent="activeTabIndex = index"
                href="#"
            >
                {{ tab.title }}
            </a>
        </li>
    </ul>
    <slot :active-tab-index="activeTabIndex" :active-tab="tabs[activeTabIndex]" />
</template>